import { put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import businessTypes from './types';
import businessServices from './services';
import businessActions from './actions';

function* getBusinessCategoriesRequest(action) {
	try {
		let response = yield sagaCallService(
			businessServices.getCategories,
			action,
			action.payload
		);
		yield put(businessActions.getCategoriesSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, businessActions.getCategoriesFailure);
	}
}

function* getBusinessRequest(action) {
	try {
		let response = yield sagaCallService(
			businessServices.getBusiness,
			action,
			action.payload
		);
		yield put(
			businessActions.getBusinessSuccess({
				response: response?.data,
				requestAction: action?.payload,
			})
		);
	} catch (e) {
		yield sagaErrorDispatcher(e, action, businessActions.getBusinessFailure);
	}
}

function* getBusinessList(action) {
	try {
		let response = yield sagaCallService(
			businessServices.getBusinessList,
			action,
			action.payload
		);
		yield put(
			businessActions.getBusinessListSuccess({
				response: response?.data,
				requestAction: action?.payload,
			})
		);
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			businessActions.getBusinessListFailure
		);
	}
}

function* getBusinessRateAndReviewRequest(action) {
	try {
		let response = yield sagaCallService(
			() => businessServices.getRateAndReview(action.payload),
			action
		);
		yield put(businessActions.getRateAndReviewSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			businessActions.getRateAndReviewFailure
		);
	}
}

function* getBusinessItem(action) {
	try {
		let response = yield sagaCallService(
			businessServices.getBusinessItem,
			action,
			action.payload
		);
		yield put(businessActions.getBusinessItemSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			businessActions.getBusinessItemFailure
		);
	}
}

function* updateBusinessCommision(action) {
	try {
		let response = yield sagaCallService(
			() => businessServices.updateBusinessCommision(action.payload),
			action
		);
		yield put(businessActions.getBusinessCommisionSuccess(response.data));
		yield (window.location = '/pwa/services/cashback/add');
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			businessActions.getBusinessCommisionFailure
		);
	}
}

function* updateBusinessRequest(action) {
	try {
		let response = yield sagaCallService(
			businessServices.updateBusiness,
			action,
			action.payload
		);
		yield put(businessActions.updateBusinessSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			businessActions.updateBusinessFailure,
			true
		);
	}
}

function* businessContractLinkRequest(action) {
	try {
		let response = yield sagaCallService(
			businessServices.contractLink,
			action,
			action.payload
		);
		yield put(businessActions.businessContractLinkSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			businessActions.businessContractLinkFailure
		);
	}
}

function* getBusinessPackageRequest(action) {
	try {
		let response = yield sagaCallService(
			businessServices.businessPackges,
			action,
			action.payload
		);
		yield put(businessActions.businessPackesSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, businessActions.businessPackesFailure);
	}
}

function* getSignContractRequest(action) {
	try {
		let response = yield sagaCallService(
			businessServices.contractSign,
			action,
			action.payload
		);
		yield put(businessActions.businessSignSuccess(response?.data));
	} catch (e) {
		if (action?.payload?.data?.showError)
			yield sagaErrorDispatcher(e, action, businessActions.businessSignFailure);
	}
}

function* getSuperBusiness(action) {
	try {
		let response = yield sagaCallService(
			businessServices.getSuperBusiness,
			action,
			action.payload
		);
		yield put(businessActions.businessSuperBusinessSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			businessActions.businessSuperBusinessFailure
		);
	}
}

function* getContractBusinessInfoHandler(action) {
	try {
		let response = yield sagaCallService(
			businessServices.getContractBusinessInfo,
			action,
			action.payload
		);
		yield put(businessActions.businessContractInfoLinkSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			businessActions.businessContractInfoLinkFailure
		);
	}
}

function* createBusiness(action) {
	try {
		let response = yield sagaCallService(
			() => businessServices.createBusiness(action.payload),
			action
		);
		yield put(businessActions.businessCreateSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, businessActions.businessCreateFailure);
	}
}
function* getCashierMachine(action) {
	try {
		let response = yield sagaCallService(
			() => businessServices.getCashierMachines(action.payload),
			action
		);
		yield put(businessActions.getCashierMachinesSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			businessActions.getCashierMachinesFailure
		);
	}
}

const businessSagas = [
	takeLatest(businessTypes.CATEGORIES.REQUEST, getBusinessCategoriesRequest),
	takeEvery(businessTypes.GET_BUSINESS.REQUEST, getBusinessRequest),
	takeLatest(businessTypes.GET_BUSINESS_List.REQUEST, getBusinessList),
	takeLatest(
		businessTypes.RATEANDREVIEW.REQUEST,
		getBusinessRateAndReviewRequest
	),
	takeLatest(businessTypes.BUSINESSITEM.REQUEST, getBusinessItem),
	takeLatest(businessTypes.CREATE_BUSINESS.REQUEST, createBusiness),
	takeLatest(businessTypes.BUSINCOMMISION.REQUEST, updateBusinessCommision),
	takeLatest(businessTypes.UPDATE.REQUEST, updateBusinessRequest),
	takeLatest(businessTypes.CONTRACT_LINK.REQUEST, businessContractLinkRequest),
	takeEvery(businessTypes.PACKAGES.REQUEST, getBusinessPackageRequest),
	takeLatest(businessTypes.SIGN.REQUEST, getSignContractRequest),
	takeLatest(businessTypes.SUPER_BUSINESS.REQUEST, getSuperBusiness),
	takeLatest(businessTypes.GET_CASHIER_MACHINES.REQUEST, getCashierMachine),
	takeLatest(
		businessTypes.CONTRACT_BUSINESS_INFO.REQUEST,
		getContractBusinessInfoHandler
	),
];

export default businessSagas;
